import { Injectable } from "@angular/core";
import { Account, AccountsService } from "clearline-api";
import { BehaviorSubject, Observable } from "rxjs";
import { filter, tap } from "rxjs/operators";

@Injectable({ providedIn: "root" })
export class CurrentAccountService {
  private currentAccountSrc$ = new BehaviorSubject<Account | null>(null);

  constructor(private accountsService: AccountsService) {}

  get account$(): Observable<Account> {
    if (!!this.currentAccountSrc$.value) {
      return this.currentAccountSrc$.asObservable().pipe(filter((account): account is Account => account !== null));
    }

    return this.accountsService.getCurrentAccount().pipe(
      tap((account) => {
        this.currentAccountSrc$.next(account);
      })
    );
  }
}
